module.exports = __webpack_public_path__ + "static/media/couple-rings_720x480.c5405f9d.jpg";